export default __webpack_public_path__ + "static/media/safety_card.861ee994.svg";